<script>
    import { _ } from "svelte-i18n";
    import { createEventDispatcher } from "svelte";
    import Button from "@smui/button";
    import { Icon } from "@smui/icon-button";
    import { mdiFileExcel } from "@mdi/js";
    import { snackbarError } from "../../../stores/AppStatus";
    import ConfirmationDialog from "../../dialogs/ConfirmationDialog.svelte";

    export let disabled = false;

    let showSupplierSelectDialog = false;
    
    const dispatch = createEventDispatcher();

</script>

<Button
    data-qa="qs-donwload-template"
    class="{disabled ? 'grey-text white-grey-outlined' : 'tescoblue-text white-tescoblue-outlined'} pr-4 nowrap"
    title={$_("download_excel_file")}
    on:click={() => {
        showSupplierSelectDialog = true;
        }}
    {disabled}
>
    <Icon tag="svg" viewBox="0 0 24 24" class="pr-0 pl-1">
        <path fill="currentColor" d={mdiFileExcel} />
    </Icon>
    {$_("download_template")}
</Button>

<ConfirmationDialog
    open={showSupplierSelectDialog}
    title={$_("download_amendment_country_template")}
    noBtnText={$_("cancel")}
    yesBtnText={$_("download")}
    big={false}
    itemData={null}
    headerColors="tescoblue white-text"
    on:reject={() => {
        showSupplierSelectDialog = false;
    }}
    on:confirm={() => {
        showSupplierSelectDialog = false;
        dispatch("downloadAmendmentCountryTemplate");
    }}
>
    {$_("do_you_want_download_amendment_country_template")}
</ConfirmationDialog>
